import { ListSuscripcionPeticion } from './../../models/completar-suscripcion/listSuscripcionPeticion';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListSuscripcionRespuesta } from '../../models/completar-suscripcion/listSuscripcionRespuesta';
import { ListPolIntValidTokenSusPeticion } from '../../models/completar-suscripcion/listPolIntValidTokenSusPeticion';
import { ListPolIntValidTokenSusRespuesta } from '../../models/completar-suscripcion/listPolIntValidTokenSusRespuesta';
import { RubroRequest } from 'src/app/models/mandatos-express/rubro-request';
import { EmpresasRubrosRespuesta } from 'src/app/models/mandatos-express/empresasRubrosRespuesta';
import { EmpresasPeticion } from 'src/app/models/mandatos-express/empresasPeticion';
import { EmpresasRespuesta } from 'src/app/models/mandatos-express/empresasRespuesta';
import { ListPacParametroPeticion } from 'src/app/models/mandatos-express/listPacParametroPeticion';
import { BuscarImagenBoleta } from 'src/app/models/mandatos-express/buscarImagenBoleta';
import { BuscarImagenRespuesta } from 'src/app/models/mandatos-express/buscarImagenRespuesta';
import { InscribirMandatosModel } from 'src/app/models/mandatos-express/addMandato';
import { ListPeticionEmbebido } from 'src/app/models/mandatos-express/listPeticionEmbebido';
import { ListRespuestaEmbebido } from 'src/app/models/mandatos-express/listRespuestaEmbebido';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Origin': '*'
  })
};

@Injectable({
  providedIn: 'root'
})
export class CompletarSuscripcionService {
  constructor(
    private http: HttpClient,
    @Inject('env') private environment: any
  ) { }

  urlSuscripcionList = this.environment.urlAmbiente + '/apiSuscripcionComercioMT/suscripcionByTokenList';
  urlSuscripcionListSusComercio = this.environment.urlAmbiente + '/apiSuscripcionComercioMT/suscripcionByTokenListSusComercio';
  urlPolIntValidTokenSusList = this.environment.urlAmbiente + '/apiSuscripcionComercioMT/polIntValidTokenSusList';
  urlPolIntValidTokenSusListSusComercio = this.environment.urlAmbiente + '/apiSuscripcionComercioMT/polIntValidTokenSusListSusComercio';
  urlEmpresaRubro = this.environment.urlAmbiente + '/apiEmpresaMT/listarRubro';
  urlEmpresaRubroSusComercio = this.environment.urlAmbiente + '/apiEmpresaMT/listarRubroSusComercio';
  urlEmpresa = this.environment.urlAmbiente + '/apiEmpresaMT/listarEmpresaHabiente';
  urlEmpresaSusComercio = this.environment.urlAmbiente + '/apiEmpresaMT/listarEmpresaSusComercio';
  urlPacParametroListar = this.environment.urlAmbiente + '/apiConvenioMT/pacParametroListar';
  urlPacParametroListarSusComercio = this.environment.urlAmbiente + '/apiConvenioMT/pacParametroListarSusComercio';
  urlBuscarImagenBoleta = this.environment.urlAmbiente + '/apiConvenioMT/seekImage';
  urlImagenBolSusComercio = this.environment.urlAmbiente + '/apiConvenioMT/seekImageSusComercio';
  urlApiMandatos = this.environment.urlAmbiente + '/apiMandatosMT/mandatoAgregar';
  urlApiMandatosSusComercio = this.environment.urlAmbiente + '/apiMandatosMT/mandatoAgregarSusComercio';
  urlApiData = this.environment.urlAmbiente + '/apiDatosPATMT/consultausuario';

  postListSusComercio(body: ListSuscripcionPeticion, isEmbebido: boolean): Observable<ListSuscripcionRespuesta> {
    let url = isEmbebido ? this.urlSuscripcionList : this.urlSuscripcionListSusComercio;
    return this.http.post<ListSuscripcionRespuesta>(url, body, httpOptions);
  }

  postListPolIntValidTokenSus(body: ListPolIntValidTokenSusPeticion, isEmbebido: boolean): Observable<ListPolIntValidTokenSusRespuesta> {
    let url = isEmbebido ? this.urlPolIntValidTokenSusList : this.urlPolIntValidTokenSusListSusComercio;
    return this.http.post<ListPolIntValidTokenSusRespuesta>(url, body, httpOptions);
  }

  postListaRubros(params: RubroRequest, isEmbebido: boolean): Observable<EmpresasRubrosRespuesta> {
    let url = isEmbebido ? this.urlEmpresaRubro : this.urlEmpresaRubroSusComercio;
    return this.http.post<EmpresasRubrosRespuesta>(url, params, httpOptions);
  }

  postListaEmpresas(body: EmpresasPeticion, isEmbebido: boolean ): Observable<EmpresasRespuesta> {
    let url = isEmbebido ? this.urlEmpresa : this.urlEmpresaSusComercio;
      return this.http.post<EmpresasRespuesta>(url, body, httpOptions);
  }

  postPacParametroListar(body: ListPacParametroPeticion, isEmbebido: boolean): Observable<any> {
    let url = isEmbebido ? this.urlPacParametroListar : this.urlPacParametroListarSusComercio;
    return this.http.post<any>(url, body, httpOptions);
  }

  postBuscarImagenBoleta(imagen: BuscarImagenBoleta, isEmbebido: boolean): Observable<BuscarImagenRespuesta> {
    let url = isEmbebido ? this.urlBuscarImagenBoleta : this.urlImagenBolSusComercio;
    return this.http.post<BuscarImagenRespuesta>(url, imagen, httpOptions);
  }

  postAddMandato(model: InscribirMandatosModel, isEmbebido: boolean) {
    let url = isEmbebido ? this.urlApiMandatos : this.urlApiMandatosSusComercio;
    return this.http.post<any>(url, model, httpOptions);
  }

  postDatosEmbebido(body: ListPeticionEmbebido): Observable<ListRespuestaEmbebido>{
    return this.http.post<ListRespuestaEmbebido>(this.urlApiData, body, httpOptions);
  }
}